import { useState } from 'react';

/**
 * Holds the open state of the study row's more-options popover. Keeps a boolean in local state and returns it with a forced-close helper and a handler that accepts the popover's own visibility changes.
 *
 * @returns The open flag, the hide helper and the visibility change handler.
 */
export const useMoreOptionsPopover = () => {
  const [open, setOpen] = useState(false);

  /**
   * Closes the study row's more-options popover. Sets the open state to false regardless of its current value.
   *
   * @returns Nothing.
   */
  const hide = () => {
    setOpen(false);
  };

  /**
   * Applies the visibility the more-options popover reports it wants. Writes newOpen straight into the open state so both opening and closing gestures are honored.
   *
   * @param newOpen - Visibility the popover is moving to.
   * @returns Nothing.
   */
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  return { open, hide, handleOpenChange };
};
